import { Component } from '@angular/core';
import { LegalLayoutComponent } from '@app/legal/layout/layout.component';

@Component({
  selector: 'app-legal-privacy-policy',
  standalone: true,
  templateUrl: './privacy-policy.component.html',
  imports: [LegalLayoutComponent],
})
export class LegalPrivacyPolicyComponent {
  protected jumpToElement(elementId: string) {
    const element = document.getElementById(elementId);
    if (!element) return;
    element.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}
